import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/series/SeriesListClient.tsx");
